<template>
    <div class="iv-page-wrapper">
        <Page
        class="iv-page-component uit-page-wrapper"
        ref="Page"
        :current="current"
        :total="total"
        :pageSize="pageSize"
        :page-size-opts="pageSizeOpts"
        :placement="placement"
        :transfer="transfer"
        :size="size"
        :simple="simple"
        :show-total="showTotal"
        :show-elevator="showElevator"
        :show-sizer="showSizer"
        :class-name="className"
        :styles="styles"
        @on-change="onChange"
        @on-page-size-change="onPageSizeChange">
        </Page>
      <div
        @click="changePage"
        class="iv-page-jump iv-text-center iv-fs-14 iv-m-r-16 iv-pointer iv-hover-border-color">GO</div>
    </div>
</template>
<script>
import {Page} from 'iview'
function isIn (value = '', array = []) {
  return array.indexOf(value) >= 0
}
export default {
  props: {
    current: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizeOpts: {
      type: Array,
      default () {
        return [10, 20, 30, 40]
      }
    },
    /*条数切换弹窗的展开方向，可选值为 bottom 和 top*/
    placement: {
      validator (value) {
        return isIn(value, ['top', 'bottom'])
      },
      default: 'bottom'
    },
    /*是否将弹层放置于 body 内，在 Tabs、带有 fixed 的 Table 列内使用时，建议添加此属性，它将不受父级样式影响，从而达到更好的效果*/
    transfer: {
      type: Boolean,
      default: false
    },
    size: {
      validator (value) {
        return isIn(value, ['small'])
      }
    },
    simple: {
      type: Boolean,
      default: false
    },
    showTotal: {
      type: Boolean,
      default: false
    },
    showElevator: {
      type: Boolean,
      default: false
    },
    showSizer: {
      type: Boolean,
      default: false
    },
    className: {
      type: String
    },
    styles: {
      type: Object
    }
  },
  components: {
    Page
  },
  methods: {
    onChange () {
      this.$emit('on-change', ...arguments)
    },
    onPageSizeChange () {
      this.$emit('on-page-size-change', ...arguments)
    },
    changePage () {
      let PageInstance = this.$refs.Page
      let target = PageInstance.$el.querySelector('.ivu-page-options-elevator input')
      let page = ~~(target.value)
      if (page > PageInstance.allPages) {
        page = PageInstance.allPages
      } else if (page <= 0 || !page) {
        page = 1
      }
      PageInstance.changePage(page)
    }
  }
}
</script>
<style lang="scss" scoped>
  .iv-page-wrapper {
      border-top: 0 none;
      overflow: hidden;
      text-align: center;
      height: 34px;
      margin: 24px 24px 0 24px;
      .iv-page-component {
          display: inline-block;
      }
      .iv-page-jump {
        padding: 4px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        transition: border-color .2s linear 0s;
        display: inline-block;
        position: relative;
        top: -12px;
        left: 8px;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/page/index.vue